import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

export const links = [
  {
    title: "Dashboard",
    path: "/dashboard/analytics",
    icon: SpaceDashboardOutlinedIcon,
    type: "button",
  },
  {
    title: "User Management",
    icon: PeopleAltOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "User List",
        path: "/dashboard/user-management/users-list",
      },
      {
        title: "Active User",
        path: "/dashboard/user-management/active-users",
      },
      {
        title: "Recent User",
        path: "/dashboard/user-management/recent-users",
      },
    ],
  },
  {
    title: "Listener Management",
    icon: SupportAgentOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Listeners",
        path: "/dashboard/listener-management/listeners-list",
      },
      {
        title: "Applications",
        path: "/dashboard/listener-management/listener-application-request",
      },
      {
        title: "Profile Approvals",
        path: "/dashboard/listener-management/listeners-profile-approvals",
      },
      {
        title: "Pending Images",
        path: "/dashboard/listener-management/pending-images",
      },
      {
        title: "Profile Updates",
        path: "/dashboard/listener-management/pending-profile-updates",
      },
    ],
  },

  {
    title: "Analytics",
    icon: InsightsOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Overview",
        // Deliberately not the bare "/dashboard/session-analytics" — the
        // sidebar's active-item check uses pathname.includes(child.path),
        // so a bare parent path here would also render "active" on every
        // other child route (e.g. .../users) since it's a string prefix.
        path: "/dashboard/session-analytics/overview",
      },
      {
        title: "Users",
        path: "/dashboard/session-analytics/users",
      },
      {
        title: "Listeners",
        path: "/dashboard/session-analytics/listeners",
      },
      {
        title: "Inactive Users",
        path: "/dashboard/session-analytics/inactive-users",
      },
      {
        title: "Inactive Listeners",
        path: "/dashboard/session-analytics/inactive-listeners",
      },
      {
        title: "Peak Hours",
        path: "/dashboard/session-analytics/peak-hours",
      },
    ],
  },
  {
    title: "Payment Management",
    icon: PaymentsOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Recharge",
        path: "/dashboard/payment-management/recharge",
      },
      {
        title: "Gift",
        path: "/dashboard/payment-management/gift",
      },
      {
        title: "Sessions",
        path: "/dashboard/payment-management/sessions",
      },
      {
        title: "Payout",
        path: "/dashboard/payment-management/payout",
      },
      {
        title: "Salary Payout",
        path: "/dashboard/payment-management/salary-payout",
      },
      {
        title: "Reconcile",
        path: "/dashboard/payment-management/reconcile",
      },
    ],
  },
  {
    title: "Recharge & Charges",
    path: "/dashboard/recharge-charges",
    icon: AccountBalanceWalletOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Plans",
        path: "/dashboard/recharge-charges/plans",
      },
      {
        title: "Gift Amounts",
        path: "/dashboard/recharge-charges/gift-manage",
      },
      {
        title: "Coupons",
        path: "/dashboard/recharge-charges/coupen-manage",
      },
      {
        title: "Charges",
        path: "/dashboard/recharge-charges/charge-manage",
      },
      {
        title: "Penalties",
        path: "/dashboard/recharge-charges/penalty-manage",
      },
    ],
  },
  {
    title: "Contact & Queries",
    path: "/dashboard/contact-queries",
    icon: ContactMailOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Report & Block",
        path: "/dashboard/contact-queries/report-block",
      },
    ],
  },
  {
    title: "Notifications",
    path: "/dashboard/notifications/send",
    icon: NotificationsActiveOutlinedIcon,
    type: "button",
  },
  {
    title: "Status",
    path: "/dashboard/status",
    icon: MonitorHeartOutlinedIcon,
    type: "button",
  },
];

// Restricted menu for the HR portal build (hr.feelixconnection.com): user
// and listener management, plus user/listener analytics (including the
// inactive-user/inactive-listener views). No dashboard, payments, recharge,
// contact/queries, notifications, or story-approval status.
export const hrLinks = [
  {
    title: "User Management",
    icon: PeopleAltOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "User List",
        path: "/dashboard/user-management/users-list",
      },
      {
        title: "Active User",
        path: "/dashboard/user-management/active-users",
      },
      {
        title: "Recent User",
        path: "/dashboard/user-management/recent-users",
      },
    ],
  },
  {
    title: "Listener Management",
    icon: SupportAgentOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Listeners",
        path: "/dashboard/listener-management/listeners-list",
      },
      {
        title: "Applications",
        path: "/dashboard/listener-management/listener-application-request",
      },
      {
        title: "Profile Approvals",
        path: "/dashboard/listener-management/listeners-profile-approvals",
      },
      {
        title: "Pending Images",
        path: "/dashboard/listener-management/pending-images",
      },
      {
        title: "Profile Updates",
        path: "/dashboard/listener-management/pending-profile-updates",
      },
    ],
  },
  {
    title: "Analytics",
    icon: InsightsOutlinedIcon,
    type: "dropdown",
    children: [
      {
        title: "Users",
        path: "/dashboard/session-analytics/users",
      },
      {
        title: "Listeners",
        path: "/dashboard/session-analytics/listeners",
      },
      {
        title: "Inactive Users",
        path: "/dashboard/session-analytics/inactive-users",
      },
      {
        title: "Inactive Listeners",
        path: "/dashboard/session-analytics/inactive-listeners",
      },
    ],
  },
];
